import { WDivider, WSkeleton, WStack } from '../../wrappers/wrapper';
import style from './user-comments-skeleton.module.scss';

const UserCommentsSkeleton = () => {
  return (
    <WStack className={style.commentCard}>
      <WStack spacing={1.5}>
        <WStack direction={'row'} spacing={1.2} alignItems={'center'}>
          <WSkeleton animation="wave" variant="rounded" width={40} height={40} />
          <WStack>
            <WSkeleton animation="wave" variant="text" width={160} height={20} />
            <WSkeleton animation="wave" variant="text" width={70} height={18} />
          </WStack>
        </WStack>
        <WSkeleton animation="wave" variant="text" width={160} height={17} />
        <WDivider />
      </WStack>
      <WStack spacing={1.5} sx={{ marginY: 1 }}>
        <WStack direction={'row'} spacing={1.2} alignItems={'center'}>
          <WSkeleton animation="wave" variant="rounded" width={40} height={40} />
          <WStack>
            <WSkeleton animation="wave" variant="text" width={160} height={20} />
            <WSkeleton animation="wave" variant="text" width={70} height={18} />
          </WStack>
        </WStack>
        <WSkeleton animation="wave" variant="text" width={160} height={17} />
        <WDivider />
      </WStack>
      <WStack spacing={1.5} sx={{ marginY: 1 }}>
        <WStack direction={'row'} spacing={1.2} alignItems={'center'}>
          <WSkeleton animation="wave" variant="rounded" width={40} height={40} />
          <WStack>
            <WSkeleton animation="wave" variant="text" width={160} height={20} />
            <WSkeleton animation="wave" variant="text" width={70} height={18} />
          </WStack>
        </WStack>
        <WSkeleton animation="wave" variant="text" width={160} height={17} />
      </WStack>
    </WStack>
  );
};

export default UserCommentsSkeleton;
